module.exports = __webpack_public_path__ + "img/41_01_040_200.142d0de2.jpg";